// custom typefaces
require("prismjs/themes/prism-tomorrow.css")

// Import analytics utilities
import { initAnalytics, trackPageView } from "./src/utils/analytics"

// Initialize analytics when the site loads
export const onClientEntry = () => {
  // Initialize analytics tracking
  initAnalytics()
}

// Track page views on route changes
export const onRouteUpdate = ({ location }) => {
  // Track page view in Google Analytics
  trackPageView(location.pathname)
}
